// Note: the enum key is used to describe the EventSystemUser in the UI. Be careful about changing it.
export enum EventSystemUser {
  SCIM = 1,
  DomainVerification = 2,
  PublicApi = 3,
}
